import { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Button, Modal, Typography } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AttendancePage from './AttendancePage';

import HolidaysPage from './HolidaysPage';
import { ReportsPage } from './ReportsPage';

export default function AttendanceManagement() {
  const [tempPointer, setTempPointer] = useState(0);
  const [pointer, setPointer] = useState(tempPointer);
  const [isChanged, setIsChanged] = useState(false);
  const [change, setChange] = useState(false);
  useEffect(() => {
    setIsChanged(false);
  }, [pointer]);
  return (
    <>
      <Box className=' p-4  '>
        <Box className='bg-blue-50 p-4 rounded-lg'>
          <Typography variant='h6' className='text-blue-700 font-bold'>
            Attendance Management System
          </Typography>
          <Typography variant='body1' className='text-gray-600'>
            Manage daily attendance and view comprehensive reports
          </Typography>
        </Box>

        <Tabs
          value={pointer}
          onChange={(event, newValue) => {
            //alert(newValue)
            setTempPointer(newValue);
            if (isChanged) {
              setChange(true);
            } else {
              setPointer(newValue);
            }
          }}
          variant='scrollable'
          scrollButtons
          allowScrollButtonsMobile
          textColor='primary'
          indicatorColor='primary'
          className='w-full '
          TabScrollButtonProps={{
            sx: {
              flexShrink: 0, // ensures scroll buttons don't collapse
            },
          }}
        >
          <Tab
            sx={{
              minHeight: 48,
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: 500,
            }}
            label=' Mark Attendance'
            icon={<PeopleIcon />}
            iconPosition='start'
          />
          <Tab
            sx={{
              minHeight: 48,
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: 500,
            }}
            label='Attendance Reports'
            icon={<AnalyticsIcon />}
            iconPosition='start'
          />
          <Tab
            sx={{
              minHeight: 48,
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: 500,
            }}
            label=' Holidays'
            icon={<CalendarMonthIcon />}
            iconPosition='start'
          />
        </Tabs>

        <TabPanel value={pointer} index={0}>
          <div className='space-y-3'>
            <AttendancePage setIsChanged={setIsChanged} />
          </div>
        </TabPanel>

        <TabPanel value={pointer} index={1}>
          <div className='space-y-6'>
            <ReportsPage />
          </div>
        </TabPanel>

        <TabPanel value={pointer} index={2}>
          <div className='space-y-6'>
            <HolidaysPage />
          </div>
        </TabPanel>
      </Box>
      <Modal open={change}>
        <div className='absolute top-1/2 left-1/2  -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-xl min-w-80 '>
          <p className='text-xl'>There are some modificaitons!</p>
          <p className='text-center text-red-400'>
            Would You like to ignore changes ?
          </p>
          <div className='flex justify-around mt-6'>
            <Button
              variant='outlined'
              color='error'
              onClick={() => {
                setChange(false);
              }}
            >
              NO
            </Button>
            <Button
              variant='outlined'
              color='success'
              onClick={() => {
                setChange(false);
                setPointer(tempPointer);
              }}
            >
              YES
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`tabpanel-${index}`}
      //  style={{
      //   display: value === index ? "block" : "none", // hide visually
      // }}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}
